export default "__VITE_ASSET__DJMVYl8$__"